import { apiSlice } from "../../api-slice";
import { GroupedIndustriesResponse } from "../../../types/type";
import { CategoryCompanyNumberData, CategoryCompanyNumberResponse, GroupCategoryData, GroupCategoryResponse, IndustryData, ProposalRequirementsFileResponse, RequirementsFileResponse, TypeOfProductData, TypeOfProductResponse } from "../group-category/group-category-api-state";

export const groupCategoryAPI = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getGroupClassification: builder.query<GroupCategoryResponse[], void>({
            query: () => '/api/group-lookup/category/GROUP_CLASSIFICATION',
            transformResponse: (response: GroupCategoryData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        businessType: builder.query<GroupCategoryResponse[], void>({
            query: () => '/api/group-lookup/category/BUSINESS_TYPE',
            transformResponse: (response: GroupCategoryData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        typeOfGroup: builder.query<GroupCategoryResponse[], void>({
            query: () => '/api/group-lookup/category/TYPE_OF_GROUP',
            transformResponse: (response: GroupCategoryData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        modeOfPayment: builder.query<GroupCategoryResponse[], void>({
            query: () => '/api/group-lookup/category/MODE_OF_PAYMENT',
            transformResponse: (response: GroupCategoryData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        // ageProfile: builder.query<ModeOfPayment, void>({
        //     query: () => '/api/group-lookup/category/AGE_PROFILE',
        //     transformResponse: (response: ModeOfPayment) => response,
        //     transformErrorResponse: (response: any) => response.data,
        // }),
        typeOfProposal: builder.query<GroupCategoryResponse[], void>({
            query: () => '/api/group-lookup/category/TYPE_OF_PROPOSAL',
            transformResponse: (response: GroupCategoryData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        prototypeType: builder.query<GroupCategoryResponse[], void>({
            query: () => '/api/financial-insurance/prototype-plans',
            transformResponse: (response: GroupCategoryData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        typeOfProduct: builder.query<TypeOfProductResponse[], void>({
            query: () => '/api/group-riders',
            transformResponse: (response: TypeOfProductData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        coverageType: builder.query<GroupCategoryResponse[], void>({
            query: () => '/api/group-lookup/category/COVERAGE_TYPE',
            transformResponse: (response: GroupCategoryData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        loanAmountType: builder.query<GroupCategoryResponse[], void>({
            query: () => '/api/group-lookup/category/LOAN_AMOUNT_TYPE',
            transformResponse: (response: GroupCategoryData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        paymentTerm: builder.query<GroupCategoryResponse[], void>({
            query: () => '/api/group-lookup/category/PAYMENT_TERM',
            transformResponse: (response: GroupCategoryData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        paymentYear: builder.query<GroupCategoryResponse[], void>({
            query: () => '/api/group-lookup/category/PAYMENT_YEAR',
            transformResponse: (response: GroupCategoryData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        getChannelType: builder.query<GroupCategoryResponse[], void>({
            query: () => '/api/group-lookup/category/CHANNEL_TYPE',
            transformResponse: (response: GroupCategoryData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        getIndustries: builder.query<GroupedIndustriesResponse, void>({
            query: () => '/api/dropdown/industries',
            transformResponse: (response: IndustryData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        getStatusProposalType: builder.query<GroupCategoryResponse[], void>({
            query: () => '/api/group-lookup/category/STATUS_PROPOSAL',
            transformResponse: (response: GroupCategoryData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        getProposalToRenewal: builder.query<GroupCategoryResponse[], void>({
            query: () => '/api/group-lookup/category/STATUS_PROPOSAL',
            transformResponse: (response: GroupCategoryData) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        getProposalRequirement: builder.query<RequirementsFileResponse[], void>({
            query: () => 'api/installation-requirements/list',
            transformResponse: (response: ProposalRequirementsFileResponse) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        getCompanyNumberType: builder.query<CategoryCompanyNumberData[], void>({
            query: () => 'api/group-lookup/category/COMPANY_NUMBER_TYPE',
            transformResponse: (response: CategoryCompanyNumberResponse) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        getContactNumberType: builder.query<CategoryCompanyNumberData[], void>({
            query: () => 'api/group-lookup/category/CONTACT_NUMBER_TYPE',
            transformResponse: (response: CategoryCompanyNumberResponse) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
    }),
});

export const { 
    useGetGroupClassificationQuery,
    useBusinessTypeQuery,
    useTypeOfGroupQuery,
    useModeOfPaymentQuery,
    useTypeOfProposalQuery,
    usePrototypeTypeQuery,
    useTypeOfProductQuery,
    useCoverageTypeQuery,
    useLoanAmountTypeQuery,
    usePaymentTermQuery,
    usePaymentYearQuery,
    useGetChannelTypeQuery,
    useGetIndustriesQuery,
    useGetStatusProposalTypeQuery,
    useGetProposalRequirementQuery,
    useGetCompanyNumberTypeQuery,
    useGetContactNumberTypeQuery
} = groupCategoryAPI;